import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  IconButton,
  Tooltip,
  Button,
  InputBase,
} from "@mui/material";
import { UseDiscountCodeReports } from "./UseDiscountCodeReports";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import OrderDeliveryDetails from "./DiscountCodeDetails";
import { moment } from "jalali-moment";

export default function DiscountCodeReports(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, goToFirstPage, setScrollTo, refresh, updatePage, updateSort } =
    UseMyPC("IsActive", "Desc");
  const { GetDiscountCodeReports, GetDiscountCodeReportsById } =
    UseDiscountCodeReports();
  const [reportRes, setReportRes] = useState();
  const [state, setState] = useState("");
  const [add, setAdd] = useState("");
  const [openDialoge, setOpenDialoge] = useState({
    show: false,
    model: undefined,
  });
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    setProgress(true);
    GetDiscountCodeReports(myPc, search, true, (callback) => {
      setReportRes(callback);
    });
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "discountCode",
      headerName: "کد تخفیف",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "logdate",
      headerName: "تاریخ ایجاد",
      width: 120,
      align: "center",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ ایجاد",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiExpiredate",
      headerName: "تاریخ انقضا",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 95,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.isActive ? "فعال" : "غیرفعال"}
          </Typography>
        );
      },
    },
    {
      field: "isPublic",
      headerName: "کاربر",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.isPublic ? "عمومی" : "سفارشی"}
          </Typography>
        );
      },
    },
    {
      field: "allOrder",
      headerName: "سفارش",
      width: 115,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.allOrder ? "عمومی" : "سفارشی"}
          </Typography>
        );
      },
    },
    {
      field: "جزئیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setProgress(true);
              GetDiscountCodeReportsById(cellValues.row.id, (callback) => {
                setOpenDialoge({ show: true, model: callback });
              });
            }}
          >
            جزئیات
          </Button>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/discountcodereports" }],
      }}
    >
      {reportRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.pageCount
              : 1
          }
          rows={reportRes ? reportRes.codes : []}
          paginationMode="server"
          page={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.page - 1
              : 1
          }
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            reportRes && reportRes.pageCondition
              ? reportRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              // cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .primary": {
              width: "100%",
              backgroundColor: "#e6d0ff !important",
            },
            "& .none": {
              width: "100%",
              backgroundColor: "#fff !important",
            },
            "& .Green": {
              backgroundColor: "#56ff004f !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.isActive) {
              return "Green";
            } else {
              return "red";
            }
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount:
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      {openDialoge.show && (
        <OrderDeliveryDetails
          setOpenDialoge={setOpenDialoge}
          openDialoge={openDialoge}
        />
      )}
    </Detail>
  );
}
